import { createContext, use } from 'react'

/**
 * A column's horizontal extent in viewport x coordinates (ADR 0023, 0025):
 * `left` is where its content starts (inside the cell padding), `right` its
 * outer edge.
 */
export interface TableFrameColumn {
  key: string
  left: number
  right: number
}

/**
 * What a TableFrame shares with the DataTable and FilterBar inside it, so a
 * list never wires one to the other itself.
 */
export interface TableFrameState {
  /** Where the table's columns sit; `null` while the table scrolls sideways. */
  columns: readonly TableFrameColumn[] | null
  /** Column keys with a filter in the toolbar (`FilterBarItem column`). */
  filteredColumns: readonly string[]
  /** The table's sticky header is pinned to the top of its scroller. */
  isStuck: boolean
  setFilteredColumns: (keys: string[]) => void
}

export const TableFrameContext = createContext<TableFrameState | null>(null)

/** The enclosing TableFrame's state, or `null` outside one. */
export function useTableFrame(): TableFrameState | null {
  return use(TableFrameContext)
}
